import { useEffect } from "react";
import ForgotPassword from "../preAuth/forgot-password";
import ForgotPasswordChange from "../preAuth/forgotpassword-change";
import ForgotPasswordOTP from "../preAuth/forgotpassword-otp";
import { useTranslation } from "react-i18next";

export default function ForgotPasswordMain({
  currentStep,
  setCurrentStep,
  data,
  setData,
}) {

  useEffect(() => {
    setCurrentStep(0)
   }, []);

  const { t } = useTranslation();
  const steps = [
    {
      title: t("common.details", {
        defaultValue: "Details",
      }),
    },
    {
      title: t("common.verify_pin", {
        defaultValue: "Verify PIN",
      }),
    },
    {
      title: t("common.complete", {
        defaultValue: "Complete",
      }),
    },
  ];

  return (
    <>
      <div>
        {currentStep == 0 && (
          <><p
          style={{ fontSize: "14px" }}
          align="left"
          className="secondary_txt_color_two"
        >
          {t("pages.forgotPassword.forgot_password_msg", {
            defaultValue:
              "Reset your password securely through our Forgot Password feature.",
          })}
        </p>
        <ForgotPassword
            data={data}
            setData={setData}
            setCurrentStep={setCurrentStep}
          /></>
          
        )}
        {currentStep === 1 && (
          <ForgotPasswordChange
            data={data}
            setData={setData}
            setCurrentStep={setCurrentStep}
          />
        )}
        {currentStep === 2 && (
          <ForgotPasswordOTP
            data={data}
            setData={setData}
            setCurrentStep={setCurrentStep}
          />
        )}
      </div>
    </>
  );
}
